export default __webpack_public_path__ + "Mission_Control.c9f76447.jpg";